import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_UserAccounts_V2_RegisterRequestV2RequestModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type RegisterV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody?: RequestModels_UserAccounts_V2_RegisterRequestV2RequestModel;
};
/**
 * Registers a customers' useraccount, using a combination of customerId and address data.
 *
 * @returns void
 */
export function registerV2(
  { businessUnit, label, customerId, requestBody }: RegisterV2,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/v2/${businessUnit}/${label}/useraccounts/customers/${customerId}/register`,
      body: requestBody,
      errors: { 400: 'If the registration process failed due to a functional error.', 409: 'Conflict' },
    },
    requestConfig,
  );
}

type RegisterForgotV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody?: RequestModels_UserAccounts_V2_RegisterRequestV2RequestModel;
};
/**
 * Registers a customers' useraccount, using a combination of customerId and address data when customer forgot their credentials.
 *
 * @returns void
 */
export function registerForgotV2(
  { businessUnit, label, customerId, requestBody }: RegisterForgotV2,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/v2/${businessUnit}/${label}/useraccounts/customers/${customerId}/registerForgot`,
      body: requestBody,
      errors: { 400: 'If the registration process failed due to a functional error.', 409: 'Conflict' },
    },
    requestConfig,
  );
}
